import { Controller } from "@hotwired/stimulus"

// Copies the source input's value and gives "Kopiert!" feedback on the button.
//
//   .field{data: { controller: "clipboard" }}
//     %input{data: { clipboard_target: "source" }, readonly: true}
//     %button{data: { action: "clipboard#copy", clipboard_target: "button" }} Kopier
export default class extends Controller {
  static targets = ["source", "button"]

  copy(event) {
    event.preventDefault()
    const text = this.sourceTarget.value
    if (navigator.clipboard) navigator.clipboard.writeText(text).catch(() => {})

    const button = this.hasButtonTarget ? this.buttonTarget : event.currentTarget
    if (!button.dataset.originalHtml) button.dataset.originalHtml = button.innerHTML
    button.innerHTML = "Kopiert!"
    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => { button.innerHTML = button.dataset.originalHtml }, 1600)
  }

  disconnect() {
    clearTimeout(this.resetTimer)
  }
}
